/* CarGauge Task 07: PLP accessibility layer. Adds semantics/keyboard to the existing theme.js filter drawer
   and view switcher. theme.js still performs every toggle; this file never changes filtering, sorting,
   pagination or fitment logic. */
(function () {
  'use strict';
  var BTN = '.sidebar_mobile, .view-as-btn a, .view-as-btn button, .sidebar_close .close';
  var mq = window.matchMedia ? window.matchMedia('(max-width: 1024px)') : { matches: false };

  function sidebar() { return document.querySelector('.page-sidebar'); }
  function toggle() { return document.querySelector('.sidebar_mobile'); }

  function isOpen() { var s = sidebar(); return !!(s && s.classList.contains('is-open')); }

  function syncDrawer() {
    var s = sidebar(), t = toggle();
    if (!s || !t) return;
    var open = isOpen();
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!s.id) s.id = 'cg-plp-filters';
    t.setAttribute('aria-controls', s.id);
    if (mq.matches) {
      s.setAttribute('role', 'dialog');
      s.setAttribute('aria-modal', open ? 'true' : 'false');
      s.setAttribute('aria-label', (t.textContent || 'Filters').replace(/\s+/g, ' ').trim());
    } else {
      s.removeAttribute('role'); s.removeAttribute('aria-modal'); s.removeAttribute('aria-label');
    }
    if (open && mq.matches && !s.contains(document.activeElement)) {
      var c = s.querySelector('.sidebar_close .close');
      if (c) c.focus();
    }
  }

  var wasOpen = false;
  function onDrawerChange() {
    var open = isOpen();
    syncDrawer();
    if (wasOpen && !open && mq.matches) { var t = toggle(); if (t) t.focus(); }
    wasOpen = open;
  }

  function syncViewAs() {
    var page = document.getElementById('collection-page');
    if (!page) return;
    Array.prototype.forEach.call(document.querySelectorAll('.view-as-btn a, .view-as-btn button'), function (a) {
      var on = page.classList.contains(a.getAttribute('data-layout'));
      a.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function syncBadge() {
    var t = toggle();
    if (!t) return;
    var n = document.querySelectorAll('.refined-widgets .refined li').length;
    var b = t.querySelector('.cg-plp-badge');
    if (!n) { if (b) b.remove(); return; }
    if (!b) { b = document.createElement('span'); b.className = 'cg-plp-badge'; t.appendChild(b); }
    b.textContent = String(n);
  }

  function init() {
    var s = sidebar(), t = toggle();
    if (t && !t.hasAttribute('data-cg-bound')) {
      t.setAttribute('data-cg-bound', '1');
      var close = document.querySelector('.sidebar_close .close');
      if (close) close.setAttribute('role', 'button');
    }
    syncDrawer(); syncViewAs(); syncBadge();
    if (s && window.MutationObserver && !s.hasAttribute('data-cg-obs')) {
      s.setAttribute('data-cg-obs', '1');
      new MutationObserver(onDrawerChange).observe(s, { attributes: true, attributeFilter: ['class'] });
    }
    var page = document.getElementById('collection-page');
    if (page && window.MutationObserver && !page.hasAttribute('data-cg-obs')) {
      page.setAttribute('data-cg-obs', '1');
      new MutationObserver(syncViewAs).observe(page, { attributes: true, attributeFilter: ['class'] });
    }
  }

  document.addEventListener('keydown', function (e) {
    var el = e.target && e.target.closest ? e.target.closest(BTN) : null;
    if (el && el.tagName === 'BUTTON') el = null; // native buttons already activate with Enter/Space
    if ((e.key === ' ' || e.key === 'Spacebar' || (e.key === 'Enter' && el && el.tagName !== 'A')) && el) {
      e.preventDefault();
      el.click();
      return;
    }
    if (!isOpen() || !mq.matches) return;
    var s = sidebar();
    if (e.key === 'Escape') {
      var c = s.querySelector('.sidebar_close .close');
      if (c) c.click();
    } else if (e.key === 'Tab') {
      var f = s.querySelectorAll('a[href], button, input:not([type=hidden]), select, [tabindex="0"]');
      var vis = Array.prototype.filter.call(f, function (n) { return n.offsetParent !== null; });
      if (!vis.length) return;
      var first = vis[0], last = vis[vis.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  if (mq.addEventListener) mq.addEventListener('change', syncDrawer);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
